import { Session } from 'src/models/Session';
import { Challenge } from 'src/models/Challenge/Challenge';
import { ChallengeSession } from 'src/models/Challenge/ChallengeSession';
import { meditationStyleId } from 'src/config';
import type { PlaylistContentType } from './api';

export type PlaylistEligibleContent = Session | ChallengeSession;

export function isPlaylistContainer(
  item: Session | Challenge | ChallengeSession,
): boolean {
  if (item.contentType === 'challenge') {
    return true;
  }
  return 'steps' in item && item.steps != null;
}

export function canAddToPlaylist(
  item: Session | Challenge | ChallengeSession,
): item is PlaylistEligibleContent {
  if (isPlaylistContainer(item)) {
    return false;
  }
  if (item.contentType === 'challengeSession') {
    return !!item.video?.viewLink;
  }
  return true;
}

export function canShowPlaylistOnListing(
  item: Session | Challenge | ChallengeSession,
  pathBase?: string,
): item is PlaylistEligibleContent {
  if (pathBase === 'challenges') {
    return false;
  }
  if (isPlaylistContainer(item)) {
    return false;
  }
  return canAddToPlaylist(item);
}

export function resolvePlaylistContentType(
  item: PlaylistEligibleContent,
  pathBase?: string,
): PlaylistContentType {
  if (item.contentType === 'challengeSession') return 'session';
  if (pathBase === 'meditations') return 'meditation';
  if (
    item.contentType === 'session' &&
    meditationStyleId &&
    item.style?.id === meditationStyleId
  )
    return 'meditation';
  return 'session';
}

export function playlistContentTypeLabel(
  contentType: PlaylistContentType,
): string {
  switch (contentType) {
    case 'meditation':
      return 'Medytacja';
    case 'challenge':
      return 'Wyzwanie';
    case 'session':
    default:
      return 'Sesja';
  }
}

export function playUrlForPlaylistItem(row: {
  contentId: string;
  contentType: PlaylistContentType;
  source: 'session' | 'challenge' | 'challenge_session';
}): string {
  if (row.source === 'challenge') return `/challenges/${row.contentId}`;
  if (row.source === 'challenge_session')
    return `/challenges/session/${row.contentId}`;
  if (row.contentType === 'meditation')
    return `/meditations/${row.contentId}`;
  return `/sessions/${row.contentId}`;
}

export function withPlaylistQueryParams(
  path: string,
  playlistId: string,
  playlistItemId: string,
): string {
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}playlistId=${encodeURIComponent(
    playlistId,
  )}&playlistItemId=${encodeURIComponent(playlistItemId)}`;
}
